import { ethers } from 'ethers';

// Kava only provider - no multichain
const KAVA_CHAIN_ID = 2222;
const KAVA_RPC_URL = 'https://evm.kava.io';

let cachedProvider: ethers.providers.JsonRpcProvider | null = null;

export function getDefaultProvider(): ethers.providers.JsonRpcProvider {
  // Return cached provider if it exists
  if (cachedProvider) {
    return cachedProvider;
  }

  cachedProvider = new ethers.providers.JsonRpcProvider(KAVA_RPC_URL, KAVA_CHAIN_ID);
  return cachedProvider;
}
